import { dateSubstract } from "app/util/date/tools/common"
import { INotificationState } from "../model"

export function getDefaultNotificationState(): INotificationState {
  return {
    serverSettings: undefined as any,
    clientSettings: undefined as any,
    isLoadingSettings: false,
    isUpdatingSettings: false,
    hasLoadingSettingsError: false,
    notifications: [],
    isLoadingNewNotification: false,
    hasLoadingNewNotificationError: false,
    lastUpdate: dateSubstract(new Date(), 5, "minutes"),
    isSliderOpened: false
  }
}
